import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useSEO } from "@/hooks/use-seo";
import {
  ReviewTableOfContents, StickyReviewHeader, ProsConsHeroBlock,
  ResponsibleGamingChecklist, AuthorBylineCard, UpdateDateLine,
} from "@/components/CasinoReviewTemplate";
import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, ChevronDown, ChevronUp,
  ExternalLink, Clock, Mail, MessageCircle, Globe, Calendar, Lock,
  Users, Flag, Trophy, Zap, Smartphone
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo1 from "@assets/logos_extracted/1.png";
import screenshotLobby from "@assets/image_1773085234293.png";
import screenshotHome from "@assets/image_1773085238958.png";
import screenshotSupport from "@assets/image_1773085219550.png";
import screenshotSports from "@assets/image_1773085213993.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://ons.lynmonkel.com/?mid=279656_1882080";

const tabs = [
  { id: "platby", label: "Platby", icon: CreditCard },
  { id: "hry", label: "Hry", icon: Gamepad2 },
  { id: "podpora", label: "Zákaznická podpora", icon: HeadphonesIcon },
  { id: "obecne", label: "Obecné informace", icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní", icon: Heart },
];

const depositMethods = [
  "PlayID", "Mastercard", "Paysafecard", "Revolut", "Skrill", "Skrill 1-Tap",
  "Neteller", "Jeton", "MiFinity", "USDTether TRC20", "USDTether ERC20",
  "USDTether BEP20", "USD Coin", "Bitcoin", "Ethereum", "Litecoin",
  "Solana", "Tron", "BNB", "Ripple", "Bitcoin Cash", "Dogecoin", "Cardano",
];

const withdrawalMethods = [
  "PlayID", "Visa", "Mastercard", "Bank Transfer", "Revolut via Bank Transfer",
  "Skrill", "Skrill 1-Tap", "Neteller", "Jeton", "MiFinity",
  "USDTether TRC20", "USDTether ERC20", "USDTether BEP20", "USD Coin",
  "Bitcoin", "Ethereum", "Litecoin", "Solana", "Tron", "BNB",
  "Ripple", "Bitcoin Cash", "Dogecoin", "Cardano",
];

const providers = "1x2Games, 3 Oaks Gaming, Amatic Industries, Amusnet (Former EGT Interactive), Apollo Games, Avatar UX, BetGames, Betsoft, BF Games, Big Time Gaming, Blueprint Gaming, Booming Games, Caleta Gaming, CT Interactive, ELA Games, Elk Studios, Endorphina, Evolution Gaming, Expanse Studios, Ezugi, Fazi, Felix Gaming, Fugaso, GameArt, GameBeat, Gaming Corps, Gamzix, Hacksaw Gaming, Holle Games, Mancala Gaming, Mascot Gaming, Merkur Gaming, NetEnt, NetGaming, Novomatic, OneTouch Games, Onlyplay, Oryx Gaming, PariPlay, Playson, Playtech, Popiplay, Quickspin, Red Rake Gaming, Red Tiger Gaming, Reevo, Relax Gaming, Revolver Gaming, Rogue, RubyPlay, SA Gaming, Shady Lady, SmartSoft Gaming, Spinmatic Entertainment, Spinomenal, Spribe, Stakelogic, Swintt, TaDa Gaming, Thunderkick, Tom Horn Gaming, Turbo Games, Vibra Gaming, Yggdrasil Gaming, Zillion Games";

const pros = [
  "Přes 3 200 slotů a bohatá živá sekce",
  "Štědré promo akce, cashbacky a VIP 1–5",
  "Rychlé výplaty, kryptoměny a nízký minimální výběr",
  "Intuitivní rozhraní a svižná mobilní verze",
  "Turnaje, denní mise a věrnostní obchod",
];

const cons = [
  "Chybí nativní mobilní aplikace",
  "Telefonická linka není k dispozici",
  "CZK v seznamu měn chybí, probíhá konverze",
  "Bonusy mají standardní podmínky protočení",
  "Některé e-peněženky se nezapočítají do bonusů",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-44 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>Rychlost výplat:</span><span className={valueClass}>3 dny</span></div>
        <div className={rowClass}>
          <span className={labelClass}>Metody vkladu:</span>
          <div className="flex flex-wrap gap-1.5">{depositMethods.map(m => <PaymentLogoPill key={m} name={m} />)}</div>
        </div>
        <div className={rowClass}>
          <span className={labelClass}>Metody výběru:</span>
          <div className="flex flex-wrap gap-1.5">{withdrawalMethods.map(m => <PaymentLogoPill key={m} name={m} />)}</div>
        </div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Počet her:</span><span className={valueClass}>Více než 13 500 her</span></div>
        <div className={rowClass}><span className={labelClass}>Automaty:</span><span className={valueClass}>Více než 10 000 her</span></div>
        <div className={rowClass}><span className={labelClass}>Ruleta:</span><span className={valueClass}>Live ruleta je dostupná</span></div>
        <div className={rowClass}><span className={labelClass}>Blackjack:</span><span className={valueClass}>Live blackjack je dostupný</span></div>
        <div className={rowClass}><span className={labelClass}>Poskytovatelé her:</span><span className={valueClass}>{providers}</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Pracovní doba:</span><span className={valueClass}>24/7</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail zákaznické podpory:</span><span className={valueClass}>support@onlyspins.com</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Dreamline Ventures SRL</span></div>
        <div className={rowClass}><span className={labelClass}>Dostupné jazyky podpory:</span><span className={valueClass}>němčina, řečtina, finština, maďarština, italština, francouzština, čeština, španělština, polština, portugalština, norština, arabština</span></div>
        <div className={rowClass}><span className={labelClass}>Živý chat:</span><span className={valueClass}>Ano</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Web:</span><span className={valueClass}><a href="https://onlyspins.com" target="_blank" rel="sponsored noopener noreferrer" className="text-[#003da5] hover:underline">https://onlyspins.com</a></span></div>
        <div className={rowClass}><span className={labelClass}>Rok založení:</span><span className={valueClass}>2026</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Dreamline Ventures SRL</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Anjouan</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky:</span><span className={valueClass}>Angličtina, Němčina, Španělština, Finština, Francouzština, Maďarština, Norština, Polština, Portugalština, Italština, Čeština, Arabština, Řečtina, Slovenština, Slovinština, Nizozemština</span></div>
        <div className={rowClass}><span className={labelClass}>Omezené země:</span><span className={valueClass}>Afghánistán, Bělorusko, Curaçao, Írán, Irák, Izrael, Malta, Severní Korea, Rusko, Spojené království, Spojené státy americké, Vietnam</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    const items: [string, string][] = [
      ["Limit vkladu:", "Ne"],
      ["Limit sázek:", "Ne"],
      ["Limit ztrát:", "Ne"],
      ["Časový limit hraní:", "Ne"],
      ["Sebevyloučení:", "Ano"],
      ["Dočasná pauza:", "Ne"],
      ["Kontrola reality:", "Ne"],
      ["Sebehodnoticí test:", "Ano"],
      ["Blokace výběrů:", "Ne"],
      ["Registr sebevyloučení:", "Ne"],
    ];
    return <ResponsibleGamingChecklist items={items} />;
  }
  return null;
}

export default function OnlySpinsPage() {
  useSEO({ title: "OnlySpins Recenze 2026 – Hodnocení 9.8 pro milovníky slotů | HrajBonus", description: "Recenze OnlySpins Casino. Obrovský výběr automatů, uvítací bonus a rychlé výplaty. Nejlepší volba pro milovníky slotů v ČR 2026. 18+",
  url: "https://hrajbonus.com/kasina/onlyspins", });

  const [activeTab, setActiveTab] = useState("platby");
  const [showAllDeposit, setShowAllDeposit] = useState(false);
  const [showAllWithdrawal, setShowAllWithdrawal] = useState(false);

  const depositVisible = showAllDeposit ? depositMethods : depositMethods.slice(0, 10);
  const withdrawalVisible = showAllWithdrawal ? withdrawalMethods : withdrawalMethods.slice(0, 10);

  return (
    <>
      <StickyReviewHeader casinoName="OnlySpins" logoSrc={logo1} rating="9.8" ctaUrl={CASINO_URL} />
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              {/* Left: logo + name + meta */}
              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo1} alt="OnlySpins logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Kasina Only Spins</h1>
                    <UpdateDateLine date="15/02/2026" authorName="Mykhailo Romaenko" />
                  </div>
                </div>

                {/* Rating stars */}
                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4,5].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                  </div>
                  <span className="text-white font-bold text-xl">9.8</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                {/* Key stats */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her", value: "13 500+" },
                    { label: "Minimální vklad", value: "250 Kč" },
                    { label: "Minimální výběr", value: "250 Kč" },
                    { label: "Licence", value: "Anjouan" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Přijímá hráče z České republiky
                </div>

                <ProsConsHeroBlock pros={pros} cons={cons} />
              </div>

              {/* Right: CTA card */}
              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus</div>
                  <div className="text-white font-black text-2xl leading-tight">až 12 500 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 200 Freespiny</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    style={{ background: "#ffffff", color: "#003da5" }}
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="OnlySpins" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            {/* ── Main content column ───────────────────────── */}
            <div className="flex-1 min-w-0 space-y-8">

              <ReviewTableOfContents />

              {/* Author opinion */}
              <AuthorBylineCard name="Mykhailo Romaenko" initials="MR" photo={mykhailoPhoto} role="Senior Content Writer" score="9.8" date="15/02/2026">
                <h2 className="font-bold text-gray-900 text-base mb-2">Názory našich autorů</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  OnlySpins působí jako moderní online kasino zaměřené hlavně na rychlost, jednoduchost a "slot-first" zážitek. Web je přehledný a svižný, orientace v lobby je snadná a platforma láká na velmi širokou nabídku her od desítek studií i živé kasino. Silnou stránkou je také důraz na rychlé výběry (zejména u e-peněženek a krypta), takže celé kasino dává dojem dobře poskládané, pohodlné služby pro hráče, kteří chtějí rychle hrát a stejně rychle vybrat.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {["Široká nabídka her", "Silné portfolio providerů", "Rychlé výběry u vybraných metod", "Podpora kryptoměn", "Přehledné a svižné prostředí, snadná orientace v lobby"].map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {["U bankovních převodů mohou výběry trvat déle", "Bonusové podmínky nemusí sedět každému"].map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </AuthorBylineCard>

              {/* Přehled kasina tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto scrollbar-hide -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* ── Review article ──────────────────────────── */}

              {/* Heading + intro */}
              <div id="prehled" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">
                  Onlyspins casino recenze 2026: co nového nabízí?
                </h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Každý rok si hráči kladou stejnou otázku: které online kasino vyniká nabídkou her, stabilitou, rychlostí výplat a promyšlenými bonusy. OnlySpins je v roce 2026 jedním z těch projektů, které se v onlyspins casino recenze 2026 o pozornost přihlásí sebevědomě. Neopírá se jen o líbivou grafiku, ale o konkrétní čísla, solidní zabezpečení a tempo vývoje, které je v herním průmyslu nutné.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Otestovali jsme klíčové oblasti, prošli uživatelské ohlasy, nahlédli do bonusové mechaniky a strávili čas přímo u stolů a automatů. Tady je přehled, co vás ve skutečnosti čeká.
                </p>

                {/* What we tested */}
                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Co jsme testovali</div>
                  <div className="grid sm:grid-cols-2 gap-2">
                    {["Herní knihovna", "Bonusy & VIP", "Platby & výběry", "Mobilní verze", "Podpora"].map(item => (
                      <div key={item} className="flex items-center gap-2 text-gray-700 text-sm">
                        <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>

                <a href="#bonusy">
                  <Button variant="outline" className="hraj-btn-light font-semibold gap-2 text-[#003da5]" data-testid="button-bonusy">
                    Přejít na bonusy <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
              </div>

              {/* Games library */}
              <div id="hry" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-1">Herní knihovna: víc než jen čísla</h2>
                <p className="text-gray-500 text-sm mb-4">Ukázka lobby a filtrování her v OnlySpins</p>

                <div className="rounded-xl overflow-hidden border border-[#dde4ee] mb-5">
                  <img src={screenshotLobby} alt="OnlySpins herní lobby" className="w-full h-auto object-cover" />
                </div>

                <p className="text-gray-600 leading-relaxed mb-4">
                  OnlySpins staví na velmi široké nabídce automatů a živých stolů. V katalogu na nás čekalo přes 3 200 video slotů od špičkových studií, od klasických ovocných kousků až po moderní megaways tituly s rozšiřujícími se válci a kaskádami. Nechybí NetEnt, Pragmatic Play, Hacksaw, ELK, Play'n GO a další stálice, které pravidelně zásobují trh svěžími nápady.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Živá sekce je zaměřena na ruletu, blackjack, baccarat a oblíbené game show. Variantu si najde hráč, který má rád standardní limity i ten, kdo preferuje vyšší sázky. Streaming je čistý, zpoždění minimální a rozhraní stolů je přehledné, takže přepínání mezi stoly nepůsobí těžkopádně.
                </p>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Zabaví i vedlejší aktivity. OnlySpins přidává turnaje na automatech, denní mini-mise a vlastní věrnostní obchod, kde se sbírají žetony a vyměňují za bonusy. Výsledkem je pocit, že se na účtu pořád něco děje, a to i v týdnech, kdy nehledáte nový velký slot.
                </p>

                <div className="bg-[#f3f6fb] rounded-xl p-4">
                  <div className="font-bold text-gray-900 text-sm mb-3">Krátký seznam toho, co v knihovně stojí za pozornost:</div>
                  <div className="space-y-2">
                    {[
                      "Drops & Wins od Pragmatic Play",
                      "Populární game show v živé sekci",
                      "Novinky s vysokou volatilitou od Hacksaw a ELK",
                      "Věrnostní výzvy a turnajové žebříčky",
                    ].map(item => (
                      <div key={item} className="flex items-center gap-2 text-gray-700 text-sm">
                        <CheckCircle className="w-4 h-4 text-[#003da5] flex-shrink-0" />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* UX + Mobile */}
              <div id="mobilni" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Uživatelské prostředí a mobilní hraní</h2>

                <div className="rounded-xl overflow-hidden border border-[#dde4ee] mb-5">
                  <img src={screenshotHome} alt="OnlySpins homepage" className="w-full h-auto object-cover" />
                </div>

                <p className="text-gray-600 leading-relaxed mb-4">
                  Rozhraní působí moderně, ale nepřeplácaně. Filtry podle poskytovatele, volatility a mechaniky usnadňují výběr. Hledání je okamžité, miniatury her mají čistý vizuál a stránka reaguje svižně. Pár minut a máte jasno, kde co je.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Na telefonu běží OnlySpins hladce. Web je responzivní a optimalizovaný pro iOS i Android. Animace nepřekáží, texty jsou čitelné, tlačítka mají rozumnou velikost. Tady je drobné mínus: chybí nativní aplikace. Nejde o zásadní problém, protože prohlížeč řeší vše spolehlivě, ale milovníci ikonky na ploše se jí nedočkají.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Rychlost je velmi dobrá i na mobilních datech. Sloty startují bez zbytečných prodlev a živé stoly si drží stabilní stream. Refresh stránky téměř nepotřebujete, a to se u delšího hraní opravdu hodí.
                </p>
              </div>

              {/* Bonuses + VIP */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy, promoakce a VIP program</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  OnlySpins si dlouhodobě drží štědrou bonusovou politiku. Platí to jak pro nové hráče, tak pro ty věrné. Kromě uvítací nabídky běží týdenní reloady, cashbacky a věrnostní program s pěti úrovněmi.
                </p>

                <div className="mb-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Co typicky uvidíte:</div>
                  <ul className="space-y-2">
                    {[
                      "Uvítací balíček s navýšením vkladu a free spiny",
                      "Pravidelné reload bonusy při dalších vkladech",
                      "Cashback až do 15 procent podle úrovně hráče",
                      "Věrnostní obchod s žetony za aktivitu",
                      "Turnaje o hotovost, free spiny a poukázky",
                    ].map(item => (
                      <li key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                        <Trophy className="w-4 h-4 text-[#c9960f] mt-0.5 flex-shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="bg-[#f3f6fb] rounded-xl p-4 mb-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Podmínky protočení jsou čitelné a v obvyklých mantinelech. Nejčastěji narazíte na:</div>
                  <ul className="space-y-1.5 text-gray-600 text-sm">
                    <li>• 35× na kombinaci vklad + bonus</li>
                    <li>• 40× na výhry z free spinů</li>
                    <li>• Sázkový limit během protočení</li>
                    <li>• Časovou platnost bonusu v řádu dní</li>
                  </ul>
                </div>

                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  Malé upozornění: vklady přes vybrané e-peněženky se někdy nezapočítávají do nároku na bonus. Týká se to hlavně uživatelů, kteří preferují okamžité wallet vklady. Není to dramatické, stačí sáhnout po kartě, bankovním převodu či kryptu a bonus dorazí bez okolků.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed">
                  VIP program není jen o odznáčcích. Od třetí úrovně počítejte s osobním přístupem a cílenými nabídkami. Vyšší cashback, rychlejší výplaty, exkluzivní turnaje a individuální promo akce výrazně mění dlouhodobý zážitek.
                </p>

                <div className="mt-5 pt-5 border-t border-[#eef1f7]">
                  <div className="font-bold text-gray-900 text-sm mb-3">Co dělá bonusy OnlySpins dlouhodobě zajímavé</div>
                  <div className="grid sm:grid-cols-2 gap-2">
                    {[
                      "Dobrý poměr výše bonusu a požadavků na protočení",
                      "Čitelné limity sázek během protočení",
                      "Pravidelné reloady i pro stálé hráče",
                      "Cashback až do 15 procent pro vyšší úrovně",
                      "Věrnostní obchod, kde žetony měníte za hodnotné odměny",
                      "Turnaje s jasnými pravidly a transparentním žebříčkem",
                    ].map(item => (
                      <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                        <CheckCircle className="w-4 h-4 text-green-500 mt-0.5 flex-shrink-0" />
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Payments */}
              <div id="platby-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Platby, měny a kryptoměny</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Z pohledu rychlosti potěší především výplaty. U e-peněženek se vyřizují do 24 hodin, karty a banky většinou pár pracovních dní. Kryptoměny přicházejí rychle, často prakticky okamžitě po schválení. Minimální výběr je nízký, již od 10 eur. Poplatky si kasino neúčtuje, platí se obvyklé bankovní či blockchainové poplatky podle zvolené sítě.
                </p>

                {/* Payment methods grid */}
                <div className="mb-5">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody vkladu</div>
                  <div className="flex flex-wrap gap-1.5">
                    {depositVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {depositMethods.length > 10 && (
                      <button
                        onClick={() => setShowAllDeposit(!showAllDeposit)}
                        className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline"
                      >
                        {showAllDeposit ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{depositMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                <div className="mb-6">
                  <div className="font-semibold text-gray-800 text-sm mb-2">Metody výběru</div>
                  <div className="flex flex-wrap gap-1.5">
                    {withdrawalVisible.map(m => (
                      <PaymentLogoPill key={m} name={m} />
                    ))}
                    {withdrawalMethods.length > 10 && (
                      <button
                        onClick={() => setShowAllWithdrawal(!showAllWithdrawal)}
                        className="flex items-center gap-1 text-[#003da5] text-xs font-semibold hover:underline"
                      >
                        {showAllWithdrawal ? (<><ChevronUp className="w-3 h-3" /> méně</>) : (<><ChevronDown className="w-3 h-3" /> +{withdrawalMethods.length - 10} dalších</>)}
                      </button>
                    )}
                  </div>
                </div>

                {/* Speed table */}
                <div className="overflow-x-auto rounded-xl border border-[#dde4ee]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-[#f3f6fb]">
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Metoda</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Odeslání výhry</th>
                        <th className="text-left px-4 py-3 font-semibold text-gray-700 text-xs">Poplatek ze strany kasina</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        ["E-peněženky", "do 24 hodin", "ne"],
                        ["Platební karta", "1–3 pracovní dny", "ne"],
                        ["Bankovní převod", "1–5 pracovních dní", "ne"],
                        ["Kryptoměny", "téměř okamžitě po schválení", "ne"],
                      ].map(([method, speed, fee], i) => (
                        <tr key={i} className="border-t border-[#eef1f7]">
                          <td className="px-4 py-3 font-medium text-gray-900">{method}</td>
                          <td className="px-4 py-3 text-gray-600">{speed}</td>
                          <td className="px-4 py-3 text-gray-400">{fee}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Customer support */}
              <div id="podpora-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora 24/7</h2>

                <div className="rounded-xl overflow-hidden border border-[#dde4ee] mb-5">
                  <img src={screenshotSupport} alt="OnlySpins centrum nápovědy" className="w-full h-auto object-cover" />
                </div>

                <p className="text-gray-600 leading-relaxed mb-5">
                  Kontakt s podporou probíhá nonstop. Nejrychlejší je živý chat, který reaguje během pár desítek vteřin. E-mailové dotazy mají slušné tempo i mimo špičku. Komunikace je stručná, ale lidská, bez pocitu robotického skriptu.
                </p>

                <div className="grid sm:grid-cols-3 gap-3">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat</div>
                      <div className="text-green-600 text-xs">24/7, rychlé reakce</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">24/7, složitější požadavky</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-gray-50 border border-gray-200 rounded-xl">
                    <HeadphonesIcon className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-700 text-sm">Telefon</div>
                      <div className="text-gray-400 text-xs">není k dispozici</div>
                    </div>
                  </div>
                </div>

                <p className="text-gray-500 text-sm mt-4 leading-relaxed">
                  Absence telefonní linky v roce 2026 překvapí málokoho. Důležitější je, že chat řeší drtivou většinu situací, od přehledu bonusových podmínek po technické rady u plateb.
                </p>
              </div>

              {/* Safety */}
              <div id="zodpovedne-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bezpečnost, férovost a kontrola nad hraním</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Bezpečnostní stránka je solidní: 256bitové SSL, jasná práce s citlivými daty a hry od studií s dlouhou historií a certifikovaným RNG. V praxi to znamená transparentní výsledky a konzistentní generování náhodných čísel.
                </p>

                <div className="font-bold text-gray-900 text-sm mb-3">Podstatná je i sada nástrojů pro kontrolu hry:</div>
                <div className="grid sm:grid-cols-2 gap-2 mb-5">
                  {[
                    "Limity vkladů, sázek a ztrát",
                    "Připomínky délky sezení",
                    "Dočasná pauza, případně delší blokace",
                    "Samostatná sekce s tipy pro bezpečné hraní",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 text-gray-600 text-sm">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Odpovědné hraní má smysl nejen u vysokých sázek. Kdo přichází hlavně za zábavou, ocení právě limity. Nastavení je rychlé a změny se projeví bez zbytečného čekání.
                </p>
              </div>

              {/* Sports betting */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Sázky na sport a e-sporty pod jednou střechou</h2>

                <div className="rounded-xl overflow-hidden border border-[#dde4ee] mb-5">
                  <img src={screenshotSports} alt="OnlySpins sportovní sázky" className="w-full h-auto object-cover" />
                </div>

                <p className="text-gray-600 leading-relaxed mb-4">
                  OnlySpins nesází pouze na kasino. V rámci jednoho účtu najdete i předzápasové a live sázky na fotbal, tenis, hokej, americké sporty a populární e-sporty. Rozhraní sázkové části působí čistě, trhy se načítají svižně a kupon se skládá intuitivně.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  U live sázek potěší možnost rychlého přidávání tipů a zobrazení základních statistik. Fanoušci e-sportů najdou CS, Dota nebo League of Legends, včetně speciálních trhů. Přepínání mezi kasinem a sázkovou částí je bez nutnosti dalšího přihlášení, což urychluje běžný denní provoz.
                </p>
              </div>

              {/* Testing experience */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Praktická zkušenost z testování</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Začáteční onboarding proběhl během několika minut. E-mailové ověření je okamžité, první přihlášení přijde s krátkým tipem na zabezpečení účtu. KYC jsme spustili dobrovolně hned po registraci, aby výplaty neměly zpoždění. Nahrání občanského průkazu a potvrzení adresy proběhlo standardně a kontrola byla hotová ještě ten den.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Vklady jsme zkusili kartou i v kryptu. Oba dorazily okamžitě. Uvítací bonus se aktivoval bez ručního zásahu, výběr slotů jsme začali na novinkách od Pragmatic Play a Hacksaw. Sloty startují svižně, zvuková stopa neklouže a FPS je stabilní i během free spinů. U živé rulety jsme ocenili pohledy kamer i srozumitelné boční menu se statistikami posledních kol.
                </p>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Po několikahodinovém hraní jsme požádali o výběr části zůstatku do e-peněženky. Schválení proběhlo během téhož dne a prostředky dorazily do 24 hodin. Výplata v BTC byla rychlejší, zde záleží jen na potvrzeních sítě. Kladně hodnotíme i to, že limity výběrů v nižších VIP úrovních nejsou nastavené přehnaně nízko.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Menší zádrhel se objevil u bonusu při vkladu přes e-peněženku, která se do nabídky nezapočítávala. Po přepnutí na kartu byl bonus dostupný bez potíží. Jde o běžné pravidlo v branži a OnlySpins ho má sepsané srozumitelně.
                </p>
              </div>

              {/* For whom */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Pro koho je OnlySpins dobrá volba</h2>
                <div className="space-y-2">
                  {[
                    "Pro lovce novinek, kteří chtějí každý týden čerstvé sloty",
                    "Pro hráče, kteří oceňují rychlé výplaty a kryptoměnové transakce",
                    "Pro milovníky živých stolů a game show",
                    "Pro uživatele, kteří mají rádi průběžné mise, turnaje a věrnostní body",
                    "Pro ty, kteří využijí i sportovní sázky pod jedním účtem",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2.5 text-gray-700 text-sm">
                      <CheckCircle className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              {/* Final Pros/Cons */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-5">Výhody a drobné nevýhody v kostce</h2>
                <div className="grid sm:grid-cols-2 gap-6">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-sm uppercase tracking-wide mb-3">
                      <CheckCircle className="w-4 h-4" /> Výhody
                    </div>
                    <ul className="space-y-2">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold text-base leading-none mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-sm uppercase tracking-wide mb-3">
                      <XCircle className="w-4 h-4" /> Nevýhody
                    </div>
                    <ul className="space-y-2">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-2 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold text-base leading-none mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <p className="text-gray-500 text-sm mt-5 leading-relaxed">
                  Všechna mínus jsou spíše praktické detaily. Webová aplikace je natolik rychlá, že absence nativní appky nebolí. A kdo chce bonus, vyřeší to volbou vhodné metody vkladu. S měnou si poradí banky i stablecoiny.
                </p>
              </div>

              {/* Tips */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Malé detaily, které zlepší zážitek</h2>
                <ul className="space-y-2.5">
                  {[
                    "Přidejte si oblíbené hry do záložky, filtr je pak otázka jedním klikem",
                    "Zapněte si připomínku délky sezení, pomáhá držet rytmus",
                    "Používejte stejnou metodu pro vklad i výběr, urychlíte zpracování",
                    "Pokud chcete bonus, vkládejte kartou, bankou nebo kryptem",
                    "Při hře v mobilu si zafixujte orientaci displeje, live stoly se ovládají lépe naležato",
                  ].map((tip, i) => (
                    <li key={i} className="flex items-start gap-2.5 text-gray-600 text-sm">
                      <Zap className="w-4 h-4 text-[#c9960f] mt-0.5 flex-shrink-0" />
                      {tip}
                    </li>
                  ))}
                </ul>

                <div className="mt-5 pt-5 border-t border-[#eef1f7]">
                  <h3 className="font-bold text-gray-900 text-sm mb-3">Otázky, které si položit před prvním vkladem</h3>
                  <ul className="space-y-2">
                    {[
                      "Jakou metodu vkladu chci použít a chci uplatnit bonus hned, nebo až později",
                      "Chci hrát v noci na mobilu, nebo na velkém monitoru u živých stolů",
                      "Vyhovuje mi měna účtu a mám vyřešenou konverzi, případně stablecoiny",
                      "Využiju spíš turnaje a mise, nebo půjdu rovnou po VIP",
                      "Mám nastavené limity vkladů a délky sezení, aby hra zůstala zábavou",
                    ].map((q, i) => (
                      <li key={i} className="flex items-start gap-2 text-gray-600 text-sm">
                        <span className="text-[#003da5] font-bold flex-shrink-0">{i + 1}.</span> {q}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="mt-5 pt-5 border-t border-[#eef1f7]">
                  <h3 className="font-bold text-gray-900 text-sm mb-3">Check-list pro plynulý start</h3>
                  <div className="space-y-2">
                    {[
                      "Registrace a ověření e-mailu",
                      "Nastavení bezpečnostních prvků účtu",
                      "Volba měny, případně krypta",
                      "Rozhodnutí o uvítacím bonusu a vhodné metodě vkladu",
                      "Přidání 10–15 oblíbených her do záložek",
                      "Zapnutí připomínek sezení a nastavení limitů",
                    ].map((item, i) => (
                      <div key={i} className="flex items-center gap-2.5 text-gray-700 text-sm">
                        <div className="w-5 h-5 rounded border-2 border-[#003da5] flex items-center justify-center flex-shrink-0">
                          <CheckCircle className="w-3 h-3 text-[#003da5]" />
                        </div>
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Performance */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Výkonnost a technická stabilita</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Během testování jsme nenarazili na chybu, která by vyžadovala restart prohlížeče. Sloty se načítaly do několika vteřin, živé stoly držely bitrate i při přepínání kamer. Web je lehký a načítá se plynule i na starších telefonech. Sběr žetonů ve věrnostním obchodě běží automaticky a odměny se objevují v účtu bez ručních zásahů.
                </p>
                <p className="text-gray-600 leading-relaxed">
                  Zvlášť oceňujeme, když se bonusy aktivují bez kontaktování podpory. U OnlySpins se tohle daří, a tím odpadá "ping-pong" v chatu. Pokud se rozhodnete bonus odmítnout, stačí klik a pokračujete bez podmínek protočení.
                </p>
              </div>

              {/* Conclusion */}
              <div id="verdikt" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <p className="text-gray-700 leading-relaxed">
                  OnlySpins si v roce 2026, jak potvrzují i 'onlyspins casino recenze 2026', drží vysoký standard v oblastech, které hráči reálně vnímají den co den. Silná knihovna, promyšlené promo akce, rychlé výplaty a kultivované rozhraní dávají smysl jak pro víkendové hraní, tak pro pravidelné krátké session. Přidejte si k tomu turnaje, věrnostní obchod a možnost sázení na sport a máte platformu, která umí bavit dlouhodobě.
                </p>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full bg-[#003da5] flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg">MR</span>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                {/* CTA card */}
                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo1} alt="OnlySpins" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">OnlySpins</div>
                      <div className="flex items-center gap-1">
                        {[1,2,3,4,5].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <span className="text-gray-600 text-xs ml-1">9.8/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus</div>
                    <div className="text-[#003da5] font-black text-xl">až 12 500 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 200 Freespiny</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      style={{ background: "#003da5" }}
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                {/* Quick info */}
                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Globe, label: "Web", value: "onlyspins.com" },
                      { icon: Calendar, label: "Rok", value: "2026" },
                      { icon: Lock, label: "Licence", value: "Anjouan" },
                      { icon: Users, label: "Provozovatel", value: "Dreamline Ventures SRL" },
                      { icon: Gamepad2, label: "Počet her", value: "13 500+" },
                      { icon: Clock, label: "Podpora", value: "24/7 Live chat" },
                      { icon: CreditCard, label: "Min. vklad", value: "250 Kč" },
                      { icon: Zap, label: "Výplaty", value: "Do 24 h (e-wallet)" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="onlyspins" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/fastslots" className="text-[#003da5] hover:underline" data-testid="review-link-fast-slots">Fast Slots</a>
              {" · "}
              <a href="/kasina/instant-casino" className="text-[#003da5] hover:underline" data-testid="review-link-instant-casino">Instant Casino</a>
              {" · "}
              <a href="/kasina/wazamba" className="text-[#003da5] hover:underline" data-testid="review-link-wazamba">Wazamba</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
